import { handleActions } from 'redux-actions'

import { issueNotification, dismissNotification } from './actions'

const defaultState = {
  collection: [],
  nextId: 0,
}

export const notificationsReducer = handleActions(
  {
    [issueNotification]: (state, { payload: { children, contextualClass }}) => ({
      ...state,
      collection: [...state.collection, {id: state.nextId, children, contextualClass}],
      nextId: state.nextId + 1,
    }),
    [dismissNotification]: (state, { payload: { id }}) => ({
      ...state,
      collection: state.collection.filter(n => n.id !== id),
    }),
  },
  defaultState
)

